<template>
  <div>
  <LineChartGenerator
    :chart-options="chartOptions"
    :chart-data="chartData"
    :chart-id="chartId"
    :dataset-id-key="datasetIdKey"
    :plugins="plugins"
    :css-classes="cssClasses"
    :styles="styles"
    :width="width"
    :height="height"
    />

  
  <v-row v-if="daterange">
    <v-col cols=12 sm=12 xs=12 md=4 lg=4>
      <v-btn v-on:click="getMonthYear()"  color="success"><v-icon>mdi-magnify</v-icon> Actualizar Gráfica</v-btn>            
    </v-col>
  </v-row>
  </div>
</template>

<script>
import{ mapMutations,mapState } from "vuex";
import { Line as LineChartGenerator } from 'vue-chartjs/legacy'

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement
} from 'chart.js'

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement
)

export default {
  name: 'LineChart',
  computed:{
        ...mapState(['saldo'])
  },
  components: {
    LineChartGenerator
  },
  props: {
    daterange:Object,
    // daterange:String,
    chartId: {
      type: String,
      default: 'line-chart'
    },
    datasetIdKey: {
      type: String,
      default: 'label'
    },
    width: {
      type: Number,
      default: 400
    },
    height: {
      type: Number,
      default: 400
    },
    cssClasses: {
      default: '',
      type: String
    },
    styles: {
      type: Object,
      default: () => {}
    },
    plugins: {
      type: Array,
      default: () => []
    }
  },
  methods:{
    ...mapMutations(["showLoading","hiddenLoading"]),
    getMonthYear(){
      // Solo toma la fecha de inicio
      // para obtener el año y el mes

      alert('Referencia fecha de inicio para tomar el año y calcular los meses ' + this.daterange.date_start);

      // sustraer
      let year=this.daterange.date_start.substr(0,4)
      // let month=this.daterange.date_start.substr(5,2)
      // let day=this.daterange.date_start.substr(8,2)
      // alert(year);
      // alert(month);
      // alert(day);
      // let FormatSimple=year+','+month+','+day;
      let FormatSimple=year+',12,01';
      const fecha = new Date(FormatSimple);
      // alert (FormatSimple);      
      // alert (fecha);
      // let month2=fecha;

      // alert(month2);            
      this.getCalculate(fecha,year);

    },
    async getCalculate(month2,year){    
      // alert(month2);
      this.showLoading({titulo:"Accediendo información",color:"primary"})  
      try{                        
          for (var i = 1; i <= month2.getMonth()+1; i+=1) {
            var month=i;        
            this.attribute.date_start=new Date(year, month - 1, 1) //Fecha del primer día del mes
            this.chartData.labels.push(this.attribute.date_start.toLocaleString('es-MX', {month: 'long'}));
            this.attribute.date_start= `${year}-${month}-${this.attribute.date_start.getDate()}` //Formateamos la fecha
            this.attribute.date_end = new Date(year, month, 0) //Fecha del último día del mes          
            this.attribute.date_end= `${year}-${month}-${this.attribute.date_end.getDate()}` //Formateamos la fecha
            // alert(this.attribute.date_start);
            // alert(this.attribute.date_end);
            await this.$store.dispatch('loadSaldo',this.attribute);               
            this.chartData.datasets[0].data.push(this.saldo[0].saldo);          
          }                
          this.loaded = true
      }catch(error){
        console.log(error);
      }  finally{
          this.hiddenLoading()
      }   
    },
  },
  
  async mounted () {    
    this.loaded = false        
    let month2=new Date();    //fecha actual
    var year=month2.getFullYear(); //Año actual
    this.getCalculate(month2,year);
    // alert(year);
          
  },
  data() {
    return {
      attribute: {sword: '',limit: 27, date_start:'',date_end:''},
      loaded: false,
      chartData: {
        labels: [],
        datasets: [
          {
            label: 'Ventas de Últimos 6 meses',
            backgroundColor: '#f87979',
            data: []
          }
        ]
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false
      }
    }
  }
}
</script>